import React from "react";
import { LegalLayout, H2, P, UL } from "@/components/LegalLayout";
import { useConsent } from "@/context/ConsentContext";
import { COMPANY } from "@/data/site";

export default function CookiePolicy() {
  const { setManagerOpen } = useConsent();
  return (
    <LegalLayout title="Cookie Policy" updated="June 2026">
      <P>
        This Cookie Policy explains how {COMPANY.name} uses cookies and similar technologies on this website, and how
        you can manage your preferences.
      </P>

      <H2>1. What are cookies?</H2>
      <P>
        Cookies are small text files placed on your device when you visit a website. They help the site function and can
        remember your preferences. Some cookies are essential; others are only used with your consent.
      </P>

      <H2>2. Our default: necessary cookies only</H2>
      <P>
        By default, we only set strictly necessary cookies required for the website to work. We do not set preference,
        analytics or marketing cookies until you have given consent through our cookie banner.
      </P>

      <H2>3. Cookie categories</H2>
      <UL
        items={[
          "Strictly necessary — required for the website to function and to remember your cookie choice. These are always on and do not require consent.",
          "Preferences — remember choices you make to improve your experience. Off until you consent.",
          "Analytics — help us understand how the site is used. We do not currently use analytics cookies; if introduced they will remain off until you consent.",
          "Marketing — used to deliver relevant advertising. We do not use marketing cookies.",
        ]}
      />

      <H2>4. Managing and withdrawing consent</H2>
      <P>
        You can change or withdraw your consent at any time. Use the button below to reopen your cookie preferences, or
        clear cookies through your browser settings. Withdrawing consent will stop any non-essential cookies from being
        set going forward.
      </P>
      <button
        onClick={() => setManagerOpen(true)}
        data-testid="reopen-cookie-preferences"
        className="mt-6 bg-[#0A1128] px-6 py-3 font-display text-sm uppercase tracking-widest text-white transition-colors hover:bg-[#1D4ED8]"
      >
        Manage cookie preferences
      </button>

      <H2>5. Contact</H2>
      <P>
        Questions about our use of cookies? Email{" "}
        <a className="underline" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
      </P>
    </LegalLayout>
  );
}
